import React from "react";
import { connect } from "react-redux";
import SpriteSelectorComponent from "../components/sprite-selector/sprite-selector.jsx";
import {
    openSpriteLibrary,
    closeSpriteSelectorModal,
} from "../reducers/modals";

const mapStateToProps = (state) => ({
    editingTarget: state.scratchGui.targets.editingTarget,
    hoveredTarget: state.scratchGui.hoveredTarget,
    raised: state.scratchGui.blockDrag,
    selectedId: state.scratchGui.targets.editingTarget,
    spriteFileInput: () => {},
    sprites: state.scratchGui.targets.sprites,
    stageSize: state.scratchGui.stageSize.stageSize,
    vm: state.scratchGui.vm
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    openSpriteLibrary: () => dispatch(openSpriteLibrary()),
    closeSpriteSelectorModal: () => dispatch(closeSpriteSelectorModal()),
    onRequestCloseSpriteLibrary: ownProps.onRequestCloseSpriteLibrary,
    onOpenSpriteSelectorModal: ownProps.onOpenSpriteSelectorModal,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SpriteSelectorComponent);
